import React, { useEffect, useState } from 'react'
import logo from './logo.svg';
import './App.css';
import Card from './components/Card'
import { Games }  from './list.js'


const Tabs = (props) => {
  const { activeKey, onSelect, tabs } = props
  return (
    <div style={{ height: 50, width: '96%', display: 'flex', justifyContent: 'space-evenly',}}> 
      <div onClick={() => onSelect(null)} style={{backgroundColor: !activeKey ? '#1e1a23' : '#1f6feb', 
          color: 'white', borderRadius: 10, cursor: 'pointer', width: 100, marginLeft: 10, marginRight: 10, paddingTop: 5}} >
        All
      </div>
      {
        tabs.map(val => {
          return (
            <div onClick={() => onSelect(val)} style={{backgroundColor: activeKey === val ? '#1e1a23' : '#1f6feb', borderRadius: 10, 
              color: 'white', cursor: 'pointer', width: 100, marginLeft: 10, marginRight: 10, paddingTop: 5}} >
              {val}
            </div>
          )
        })
      }
    </div>
  )
}

const App = props => 
{
  useEffect(() => {
    document.title = "tatsunical games archive"
    document.logo = logo
  }, [])

  var tabs = [2021,2022,2023,2024]
  const [key, setKey] = useState(null);

  var GamesList = Games.map(game => {
    if(key === null || game.year === key) {
      return (
        <Card link={game.link} id={game.id} img={game.img}/>
      )
    }
  })
          

  return (
    <div className="App">
      <header className="App-header"> 
      <div style={{padding: 10, position: 'fixed', top: 0, backgroundColor: '#283044', 
                  zIndex: 3, justifyContent: 'center', display: 'flex', borderRadius: 10, boxShadow: '2px 2px 30px black'}}>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          tabs={tabs}
          onSelect={(k) => setKey(k)}
          className="mb-3"/>
      </div>
        <div style={{paddingLeft: 100, marginTop: 70}} className="body">
          {GamesList}
        </div>
      </header>
    </div>
  );
}

export default App;
